// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S_7t","type":"styles_type__17LOA","choices":"styles_choices__1lJGV"};